import { Zap, QrCode, Globe, Send, Mail, Gauge } from "lucide-react";
import { Reveal, MaskLines } from "./motion";
import { GALLERIES } from "../../lib/assets";
import { DeviceMock } from "./Glass";

const Feature = ({ icon: Icon, title, children, testId }) => (
  <div
    data-testid={testId}
    className="lg-surface flex h-full flex-col justify-between rounded-3xl p-7 transition-transform duration-300 hover:-translate-y-0.5"
  >
    <Icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
    <div className="mt-10">
      <h3 className="font-display text-2xl text-ink md:text-3xl">{title}</h3>
      <p className="mt-2 font-body text-sm leading-relaxed text-ink-soft">
        {children}
      </p>
    </div>
  </div>
);

export const Pagos = () => {
  return (
    <section
      id="pagos"
      data-testid="pagos-section"
      className="min-h-screen px-6 pb-24 pt-28 md:px-12"
    >
      <div className="mx-auto max-w-6xl">
        <h2 className="max-w-3xl font-display text-4xl font-normal leading-none tracking-tight text-ink md:text-6xl">
          <MaskLines lines={["Envía, cobra y recibe", "en segundos."]} />
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-ink-soft md:text-lg">
            Opera MXF sobre la Fragoso Smart Chain con comisiones muy bajas.
            Manda transferencias sabiendo siempre a quién le envías — por FSC ID
            o desde tus contactos guardados.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-12">
          {/* Large block: device + real-time collection */}
          <Reveal className="md:col-span-7">
            <div className="lg-surface relative flex h-full flex-col overflow-hidden rounded-3xl p-8 md:p-10">
              <div className="max-w-sm">
                <span className="font-accent text-xs uppercase tracking-[0.2em] text-ink-soft">
                  Operación diaria
                </span>
                <h3 className="mt-3 font-display text-3xl text-ink md:text-4xl">
                  Tu cuenta Aurexis, siempre a la vista.
                </h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-ink-soft">
                  Consulta tu saldo, entra a pagos y cobros, revisa tus
                  movimientos y accede a tus servicios desde un mismo lugar.
                </p>
              </div>
              <DeviceMock
                src={GALLERIES.pagos[0].src}
                alt={GALLERIES.pagos[0].alt}
                className="mt-6 min-h-[360px] flex-1"
                imgClassName="max-h-[440px]"
              />
            </div>
          </Reveal>

          {/* Right column stacked features */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:col-span-5">
            <Reveal delay={0.05}>
              <Feature icon={Zap} title="Instantáneo" testId="feature-instant">
                Enviar y recibir en segundos, sin fricción.
              </Feature>
            </Reveal>
            <Reveal delay={0.1}>
              <Feature icon={Gauge} title="Comisiones bajas" testId="feature-fees">
                Costos mínimos en cada operación sobre la FSC.
              </Feature>
            </Reveal>
            <Reveal delay={0.15}>
              <Feature icon={QrCode} title="Paga con QR" testId="feature-qr">
                Cobra por QR o directamente desde un contacto.
              </Feature>
            </Reveal>
            <Reveal delay={0.2}>
              <Feature icon={Send} title="Por FSC ID" testId="feature-fscid">
                Transfiere por FSC ID o contactos guardados.
              </Feature>
            </Reveal>
          </div>

          {/* Bottom row: plugin + glass tickets */}
          <Reveal className="md:col-span-7" delay={0.05}>
            <div className="lg-surface flex h-full flex-col justify-between rounded-3xl p-8 text-ink md:p-10">
              <Globe className="h-6 w-6 text-gold" strokeWidth={1.5} />
              <div className="mt-10">
                <h3 className="font-display text-3xl text-ink md:text-4xl">
                  Plugin de cobros para tu web.
                </h3>
                <p className="mt-3 max-w-md font-body text-sm leading-relaxed text-ink-soft">
                  Conecta Aurexis a tu página y empieza a recibir pagos en MXF
                  directamente desde tu sitio, con la misma seguridad de la
                  cadena privada.
                </p>
              </div>
            </div>
          </Reveal>
          <Reveal className="md:col-span-5" delay={0.1}>
            <Feature icon={Mail} title="Tickets en tu mail" testId="feature-tickets">
              Recibe el comprobante de cada operación en tu correo y consúltalo
              cuando quieras desde Glass.
            </Feature>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
